import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { listJobs } from '../../../../../../insfrastructure/services/jobs'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import { formatExperience } from '../../../../../../insfrastructure/utils/object-utils'
import searchIcon from '../../../../../../assets/icons/search.png'
import filterIcon from '../../../../../../assets/icons/filter.png'

export default class Oportunities extends Component {
    state: Record<string, any> = {
        job_types: [],
        job_results : [],
        loading_job: false,
        slides: [
          'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoNoticias/7daf2200-2aca-11ed-aa6e-9587410378a2/melkor-morgoth.jpg',
          'https://images.nightcafe.studio/jobs/Qgdvd7TlGKDSABG5r7Ie/Qgdvd7TlGKDSABG5r7Ie--1--mew4h.jpg?tr=w-1600,c-at_max'
        ]
    }

    BRLReal = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })

    async componentDidMount() {
        setTimeout(() => {
          this.getStaticValues(); 
        });

        try {
          const job_results = (await listJobs({ offset: 0, limit: 3 })).data;
          
          this.setState({ job_results });
        } catch (error) {};
    }

    getStaticValues = async () => {
      try {  
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
        const job_types = staticValues.job_type;
    
        this.setState({ job_types });
      } catch (error) {}
    }

    render() {
        return (
            <div className='oportunities'>
              <div className='content'>
                  <h1>OPORTUNIDADES <span>EMPREGA MECÂNICO</span></h1>

                  <div className='job-results'>
                  {
                      !this.state.loading_job ?
                      <>
                      {
                          this.state.job_results.length === 0 ?
                          <p>Nenhuma oportunidade encontrada</p> :
                          this.state.job_results.map((x: any, i:number) => 
                          <div key={'job_'+i} className='job'>
                            <div className='top-row'>
                                <div className='job-info'>
                                <div className='main'>
                                    <h3>{x.jobTitle.name}</h3>
                                    <p>{x.company.name}</p>
                                </div>
                                {/* <div className='location'>
                                    <p>{x.city.displayName}</p>
                                </div> */}
                                <div className='salary'>
                                    <p>{x.showSalary ? this.BRLReal.format(x.salary) : 'A combinar'}</p>
                                </div>
                                </div>
                                {window.innerWidth > 1000 &&
                                <div className='sign-in'>
                                    <Link to={'/offers/'+x.jobpostId+'/details'}><button className='primary'>Candidatar-se</button></Link>
                                </div>}
                            </div>
                            <div className='bottom-row'>
                                <div className='experience'>
                                <p><b>Experiência:</b> {formatExperience(x.minimumExperience)}</p>
                                </div>
                                <div className='observations'>
                                <p dangerouslySetInnerHTML={{__html: x.jobDescription}}></p>
                                </div>
                                <div className='type'>
                                <span>{this.state.job_types[x.jobType?.toLowerCase()] || x.jobType || 'Efetiva'}</span>
                                </div>
                            </div>
                            {window.innerWidth <= 1000 &&
                            <div className='sign-in'>
                                <Link to={'/offers/'+x.jobpostId+'/details'}><button className='primary'>Candidatar-se</button></Link>
                            </div>}
                          </div>)
                      }
                      </> : 
                      <>
                          <p>Carregando...</p>
                      </>
                  }
                  </div>
                  {this.state.job_results.length > 0 && (
                    <div className='see-more-container'>
                      <Link to='/offers'>
                        <button className='see-more-btn'>Ver mais vagas</button>
                      </Link>
                    </div>
                  )}
              </div>
            </div>
        )
    }
}
